import {CollectionFactory, Reducer} from '@modifi/redux'
import {getAuthenticatedThemisClient} from '@modifi/onboarding-api-clients'

import {AppThunkAction} from '../../types/redux'

const apiClient = getAuthenticatedThemisClient()

const {actions, selectors, reducer} = CollectionFactory({
  actionNamePrefix: 'data/registrationTypes/collection',
  reducerPath: ['data', 'registrationTypes', 'collection'],
  fetchRequest: (state, {countryCode}) =>
    apiClient.StaticData.registrationTypes({countryCode: countryCode?.toUpperCase()})?.then(
      res => res?.data()?.registrationTypes || []
    ),
  entityPrimaryKeySelector: entity => entity?.type!,
})

export const selectRegistrationTypesByCountryCode = (
  state: Record<string, any>,
  countryCode: string
): string[] => selectors?.selectByKeyWindow(state, {countryCode: countryCode?.toUpperCase()})

export default reducer as Reducer

export const aFetchRegistrationTypesByCountryCode = (countryCode: string): AppThunkAction =>
  actions!.fetch({countryCode})
